"use strict";

var _regeneratorRuntime = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _asyncToGenerator = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/tapanshah/aenetworks/aetn.editorials.washington/node_modules/@babel/runtime/helpers/inherits");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _react = require("react");

var _propTypes = require("prop-types");

var HtmlElement =
/*#__PURE__*/
function (_react$Component) {
  _inherits(HtmlElement, _react$Component);

  function HtmlElement() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, HtmlElement);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(HtmlElement)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _this.unmount = function () {};

    return _this;
  }

  _createClass(HtmlElement, [{
    key: "componentDidMount",
    value: function () {
      var _componentDidMount = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee() {
        var _this$props, tag, beforeMount, mount, element;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this$props = this.props, tag = _this$props.tag, beforeMount = _this$props.beforeMount, mount = _this$props.mount;
                _context.next = 3;
                return beforeMount();

              case 3:
                if (!_context.sent) {
                  _context.next = 8;
                  break;
                }

                element = document.createElement(tag);
                _context.next = 7;
                return mount(element);

              case 7:
                this.unmount = function () {
                  return element.parentNode.removeChild(element);
                };

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function componentDidMount() {
        return _componentDidMount.apply(this, arguments);
      }

      return componentDidMount;
    }()
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.unmount();
    }
  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);

  return HtmlElement;
}(_react.Component);

exports["default"] = HtmlElement;
HtmlElement.propTypes = {
  tag: _propTypes.string.isRequired,
  mount: _propTypes.func.isRequired,
  beforeMount: _propTypes.func
};
HtmlElement.defaultProps = {
  beforeMount: function beforeMount() {
    return true;
  }
};